//CART CALLBACKS

// cart toggle
var cartToggle = document.getElementById('cart-toggle');
var viewCart = document.getElementById('view-cart');

if (cartToggle) {
  cartToggle.addEventListener("click", function() {
    window.monster_refresh(true);
  });
}

if (viewCart) {
  viewCart.addEventListener("click", function() {
    window.openCart();
    window.monster_refresh(true);
  });
}

// Show spinner
window.CART_ADD = function() {
  var addButtonSpinner = document.querySelector('.product-form__spinner > .icon-spinner');
  if(addButtonSpinner) {
    addButtonSpinner.classList.add('loading');
    addButtonSpinner.classList.remove('hidden');
  }
};

document.addEventListener('DOMContentLoaded', function() {
  // Find all add to cart buttons
  var addToCartButtons = document.querySelectorAll('button[name="add"].product-form__submit');
  
  // Add click event listener to each button
  addToCartButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      // Only run CART_ADD if button is not disabled
      if (!button.disabled) {
        window.CART_ADD();
      }
    });
  });
});

// Hide spinner
window.addToCartCallBack = function(item, items) {
  var addButtonSpinner = document.querySelector('.product-form__spinner > .icon-spinner');
  if(addButtonSpinner) {
    addButtonSpinner.classList.remove('loading');
    addButtonSpinner.classList.add('hidden');
  }
}

// Cart updated
 document.addEventListener("cart:updated", ({detail: { items }}) => {
  fetch(window.Shopify.routes.root + "?section_id=intus-header")
  .then((response) => response.text())
  .then((responseText) => {
    let html = new DOMParser().parseFromString(responseText, 'text/html');
    let destination = document.getElementById('cart-toggle');
    let source = html.getElementById('cart-toggle');
    if (source && destination) destination.innerHTML = source.innerHTML;
  });
});

// Splide 
if (window.splideLoaded) {
  // If scripts are already loaded, execute immediately
  loadSplideInstances();
} else {
  // Wait for the scriptsLoaded event
  document.addEventListener('splideLoaded', loadSplideInstances);
}

function loadSplideInstances() {
  // hero panels
  var elms = document.querySelectorAll( '.splide.intus-hero' );
  if(elms != null && elms.length > 0) {
    for ( var i = 0; i < elms.length; i++ ) {
      var list = elms[i].querySelector('.splide__list');
      var slideCount = list.children.length;
      var type = (slideCount > 1) ? 'loop' : 'fade';
      var splide = new Splide(elms[i], {
            type: type,
            arrows: false,
            autoplay: slideCount > 1,
            pagination: slideCount > 1,
            lazyLoad:'nearby'
          }).mount();  
    }
    
    // Initialize video handling for carousel components
    initVideoCarousels();
  }

  // announcement-bar
  new Splide('.announcement-bar', {
    type: 'loop',
    arrows: false,
    autoplay: true,
    pagination: false
  }).mount();
}

// Handle video carousels
function initVideoCarousels() {
  // Find all carousel sections on the page
  var carouselSections = document.querySelectorAll('.intus-hero-wrapper');
  
  carouselSections.forEach(function(section) {
    // Get section ID from the closest Shopify section container
    var sectionContainer = section.querySelector('.splide').closest('[id^="shopify-section"]');
    if (!sectionContainer) return;
    
    var sectionId = sectionContainer.id.replace('shopify-section-', '');
    handleSectionVideos(sectionId, section);
  });
  
  // Add global resize handler for responsive video display
  if (carouselSections.length > 0 && !window.videoResizeHandlerAdded) {
    window.addEventListener('resize', function() {
      carouselSections.forEach(function(section) {
        if (typeof section.updateVideoDisplay === 'function') {
          section.updateVideoDisplay();
        }
      });
    });
    window.videoResizeHandlerAdded = true;
  }
}

// Handle videos for a specific carousel section
function handleSectionVideos(sectionId, sectionElement) {
  // Find all video placeholders in this section
  var videoPlaceholders = sectionElement.querySelectorAll('[class*="video-placeholder-' + sectionId + '"]');
  
  if (videoPlaceholders.length === 0) {
    console.log('No video placeholders found for section:', sectionId);
    return;
  }
  
  console.log('Found ' + videoPlaceholders.length + ' video placeholders for section:', sectionId);
  
  function createAndInsertVideo(placeholder) {
    // Clear any existing videos first
    var container = placeholder.parentElement;
    var existingVideos = container.querySelectorAll('video');
    
    // Fixed: Make sure we're only removing videos that are actually children of this container
    existingVideos.forEach(function(video) {
      video.pause();
      // Check if this video is a child (or nested child) of the container before removing
      if (container.contains(video) && video.parentNode) {
        // Remove from the actual parent, not necessarily the container
        video.parentNode.removeChild(video);
      }
    });
    
    // An alternative approach: remove all video wrappers instead
    var existingWrappers = container.querySelectorAll('.video-wrapper');
    existingWrappers.forEach(function(wrapper) {
      if (wrapper.parentNode === container) {
        container.removeChild(wrapper);
      }
    });
    
    // Get the data attributes
    var isMobile = window.innerWidth < 1024;
    var videoSrc = isMobile ? placeholder.getAttribute('data-mobile-src') : placeholder.getAttribute('data-desktop-src');
    var posterSrc = isMobile ? placeholder.getAttribute('data-mobile-poster') : placeholder.getAttribute('data-desktop-poster');
    var autoplay = placeholder.getAttribute('data-autoplay') === 'true';
    var loop = placeholder.getAttribute('data-loop') === 'true';
    var muted = placeholder.getAttribute('data-muted') === 'true';
    var slideIndex = placeholder.getAttribute('data-slide-index');
    
    // If there's no video source for current device, don't create video
    if (!videoSrc) {
      console.log('No video source for ' + (isMobile ? 'mobile' : 'desktop') + ' in section ' + sectionId + ', slide ' + slideIndex);
      return;
    }
    
    console.log('Creating video for ' + (isMobile ? 'mobile' : 'desktop') + ' in section ' + sectionId + ', slide ' + slideIndex);
    
    // Create new video element with anti-flicker attributes
    var video = document.createElement('video');
    video.className = isMobile ? 
      'mobile-video mobile-video-' + sectionId + '-' + slideIndex : 
      'desktop-video desktop-video-' + sectionId + '-' + slideIndex;
    
    // Set attributes - force autoplay and muted for immediate playback
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('disablePictureInPicture', '');
    video.setAttribute('disableRemotePlayback', '');
    
    if (loop) video.setAttribute('loop', '');
    if (posterSrc) video.setAttribute('poster', posterSrc);
    video.setAttribute('data-slide-index', slideIndex);
    video.setAttribute('data-section-id', sectionId);
    
    // Add preload attribute to start loading immediately
    video.setAttribute('preload', 'auto');
    
    // Anti-flicker attributes
    video.style.transform = 'translateZ(0)';
    video.style.webkitTransform = 'translateZ(0)';
    video.style.backfaceVisibility = 'hidden';
    video.style.webkitBackfaceVisibility = 'hidden';
    
    // Create and add source element
    var source = document.createElement('source');
    source.src = videoSrc;
    source.type = 'video/mp4';
    video.appendChild(source);
    
    // Hide placeholder image if it exists
    var posterImg = placeholder.querySelector('.video-poster');
    if (posterImg) {
      posterImg.style.display = 'none';
    }
    
    // Create a wrapper to contain the video (helps with flicker)
    var videoWrapper = document.createElement('div');
    videoWrapper.className = 'video-wrapper';
    videoWrapper.style.position = 'absolute';
    videoWrapper.style.top = '0';
    videoWrapper.style.left = '0';
    videoWrapper.style.width = '100%';
    videoWrapper.style.height = '100%';
    videoWrapper.style.overflow = 'hidden';
    videoWrapper.style.transform = 'translateZ(0)';
    videoWrapper.style.webkitTransform = 'translateZ(0)';
    
    // Add the video to the wrapper
    videoWrapper.appendChild(video);
    
    // Insert wrapper before the placeholder
    container.insertBefore(videoWrapper, placeholder);
    
    // Reduce scroll event impact
    var scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) {
        // During scroll, optionally hide video
        video.style.opacity = '0.99'; // Slight opacity change can reduce flicker
        clearTimeout(scrollTimeout);
      }
      
      scrollTimeout = setTimeout(function() {
        // After scroll stops
        video.style.opacity = '1';
      }, 50);
    }, { passive: true });
    
    // Play the video with multiple fallbacks
    setTimeout(function() {
      // Method 1: Standard play()
      var playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.then(function() {
          console.log('Video playback started successfully');
        }).catch(function(error) {
          console.log('Autoplay failed: ' + error);
          
          // If autoplay fails, try again with muted
          video.muted = true;
          video.play().catch(function(e) {
            console.log('Autoplay still failed even with muted: ' + e);
          });
        });
      }
      
      // Method 2: Set current time to force re-evaluation
      video.currentTime = 0.1;
    }, 100);
    
    // Add loadeddata event to try playing again when actually loaded
    video.addEventListener('loadeddata', function() {
      video.play().catch(function(error) {
        console.log('Play on loadeddata failed: ' + error);
      });
    });
    
    video.addEventListener('loadedmetadata', function() {
      // This ensures the video is fully loaded before it can be accessed by trackers
      if (typeof video.seek === 'undefined') {
        // Define a dummy seek method if it doesn't exist
        video.seek = function(time) {
          if (time !== undefined) {
            this.currentTime = time;
          }
          return this.currentTime;
        };
      }
    });
    
    return videoWrapper;
  }

  // Process all placeholders
  videoPlaceholders.forEach(createAndInsertVideo);
  
  // Function to update videos on resize
  function updateVideoDisplay() {
    console.log('Updating video display for section:', sectionId);
    videoPlaceholders.forEach(createAndInsertVideo);
  }
  
  // Initialize for this section
  updateVideoDisplay();
  
  // Store reference to this function with the section element
  sectionElement.updateVideoDisplay = updateVideoDisplay;
}
 
// component: accordion
var accordionToggleArr = document.querySelectorAll('.accordion > .toggle');

Array.from(accordionToggleArr).forEach(function(element) {
  element.addEventListener("click", function() {
    element.parentElement.setAttribute('aria-expanded', element.parentElement.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  });
});

// get cart
function getCart() {
  return fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });
}

// variant selector
class VariantSelects extends HTMLElement {

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateImages() {
    document.getElementById("media-slider").innerHTML = "";
    for (let [index, placeholder] of variantMedia[this.currentVariant.id].images_placeholder.entries()) {
      const div = document.createElement("li");
      const wrapper = document.createElement("div");
      const node = document.createElement("img");
      const imageDesktop = variantMedia[this.currentVariant.id].images_desktop[index];
      const imageMobile = variantMedia[this.currentVariant.id].images_mobile[index];
      const imageDataSet = imageDesktop + ", " + imageMobile + " 600w";
  
      // Load first image eagerly, lazy load the rest
      if (index === 0) {
        // First slide - load immediately
        node.setAttribute("srcset", imageDataSet);
        node.setAttribute("decoding", "async"); // Help browser optimize rendering
      } else {
        // Other slides - use Splide's lazy loading
        node.setAttribute("data-splide-lazy-srcset", imageDataSet);
      }
      
      node.alt = this.currentVariant.title;
      wrapper.classList.add("media-slider--img-container");
  
      div.classList.add("splide__slide");
      div.classList.add("placeholder");
      div.appendChild(wrapper);
      wrapper.appendChild(node);
      document.getElementById("media-slider").appendChild(div);
    }
  }

  updateVideo() {
    if (variantMedia[this.currentVariant.id].video != null) {
      const div = document.createElement("li");
      div.setAttribute("data-splide-html-video", variantMedia[this.currentVariant.id].video);
      
      div.classList.add("splide__slide");
      div.classList.add("hidden-desktop");
      div.classList.add("media-slider__video");   
      div.classList.add("placeholder");
      document.getElementById("media-slider").appendChild(div);
    }
  }

  createSlider() {
      this.gallery = new Splide('.media-gallery', {
        type       : 'slide',
        perPage    : 4,
        perMove    : 1,
        rewind     : false,
        pagination : false,
        arrows     : true,
        lazyLoad   : 'nearby',
        breakpoints: {
          769: {
            perPage: 1
          },
          1200: {
            perPage: 2
          },
          1800: {
            perPage: 3
          }
        }
      });
      this.gallery.mount();
  }

  updateCarousel() {
    this.createSlider();
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    if (!variantMedia) return;

    this.updateImages();
    this.updateCarousel();
  }

  updateColorValue() {
    if (!this.currentVariant) return;
    const colorValueName = document.getElementById('ColorValue');
    if (!colorValueName) return;
    colorValueName.innerHTML = this.currentVariant.option2;
  }
  
  updateRadioButton(optionName, optionValue, isAvailable) {
    if (optionName.includes("Size")) {
      let radioButton = document.getElementById(handleize(optionName) + "-" + optionValue);
      if (radioButton) {
        isAvailable ? radioButton.classList.remove("sold-out") : radioButton.classList.add("sold-out");
      }
    }
  }

  updateSizeAvailability() {
    this.variantData
      .filter(variant => variant.option2 == this.currentVariant.option2)
      .forEach(variant => {
        if (variantData[variant.id]) {
          this.updateRadioButton(variantData[variant.id].option1, variant.option1, variant.available);
          this.updateRadioButton(variantData[variant.id].option2, variant.option2, variant.available);
        }      
      });
  }

  updateBadges() {
    let preorderButton = document.getElementById("badge-preorder");
    if(preorderButton != null)
    {
      if (variantData[this.currentVariant.id].preorder == true && variantData[this.currentVariant.id].qty < 1) {
        preorderButton.classList.remove("hidden");
      } else {
        preorderButton.classList.add("hidden");
      }
    }

    let clearanceButton = document.getElementById("badge-clearance");
    if(clearanceButton != null) {
      if (variantData[this.currentVariant.id].clearance == true) {
        clearanceButton.classList.remove("hidden");
      } else {
        clearanceButton.classList.add("hidden");
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    
    if (window.location.href.indexOf("bundles") > -1) {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}#bundles`);
    } else {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
  }

  updateStickySizeSelector() {
    const selector = document.querySelector("#sticky-size-selector");
    if (!selector) return;
    
    Array.from(selector.options).forEach((option, i) => {
      if(option.value == this.currentVariant.option1) {
        selector.selectedIndex = i;
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const sectionsArr = [`product-name`,`sticky-selector`,`product-badges`, `price-${this.dataset.section}`];
        Array.from(sectionsArr).forEach(id => {
          this.renderSection(responseText, id);
        });

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true);
      });

    const lookSection = this.dataset.section.replace('main', 'shop-the-look');
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${lookSection}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `looks`;
        this.renderSection(responseText, id);
      });
  }

  renderSection(responseText, id) {
    let html = new DOMParser().parseFromString(responseText, 'text/html');
    let destination = document.getElementById(id);
    let source = html.getElementById(id);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const addSpinner = productForm.querySelector('.product-form__spinner .icon-spinner');

    if (!addButton) return;

    try {
      addButtonText.textContent = '';
      addButton.classList.add('loading');
      addSpinner.classList.remove('hidden');

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
      addSpinner.classList.add('hidden');
      addButton.classList.remove('loading');
    } catch (e) {
      console.log("Add button not found.");
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateColorValue();
      this.updateBadges();
      this.updateSizeAvailability();
      this.updateStickySizeSelector();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  constructor() {
    super();
  }

  executeAfterScriptsLoad = () => {
    this.onVariantChange();
    this.addEventListener('change', this.onVariantChange);
  };
  
  connectedCallback() {
    if (window.splideLoaded) {
      // If scripts are already loaded, execute immediately
      this.executeAfterScriptsLoad();
    } else {
      // Wait for the scriptsLoaded event
      document.addEventListener('splideLoaded', this.executeAfterScriptsLoad);
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

//sticky size selector
class StickySelector extends HTMLElement {
    constructor() {
      super();
      this.selector = this.querySelector('select');
      if (this.selector) {
        this.selector.addEventListener("change", this.onSelectUpdated.bind(this));
      }
    }

   onSelectUpdated() {
     var variantRadios = document.querySelector('variant-radios');
     if (!variantRadios) return;
     
     var index = this.selector.selectedIndex;
     var value = this.selector.options[index].getAttribute('value');
     variantRadios.querySelector("input[value='"+value+"']").click();
   }
 }

customElements.define('sticky-selector', StickySelector);

//zoom
const zoomBtn = document.getElementsByClassName("slider--zoom")[0];

function zoomIn() {
  document.querySelector('.slider--controls').classList.add("zoomed");
  document.querySelector('.product__selector-container').classList.add("zoomed");
  zoomBtn.removeEventListener('click', zoomIn, false);
  zoomBtn.addEventListener('click', zoomOut, false);
}

function zoomOut() {
  document.querySelector('.slider--controls').classList.remove("zoomed");
  document.querySelector('.product__selector-container').classList.remove("zoomed");
  zoomBtn.removeEventListener('click', zoomOut, false);
  zoomBtn.addEventListener('click', zoomIn, false);
}

if (zoomBtn) {
  zoomBtn.addEventListener('click', zoomIn, false);
}

// Shopify JS
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true
    });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

function handleize(text) {
  return text.toString().toLowerCase()
             .replace(/\s+/g, '-')           // Replace spaces with -
             .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
             .replace(/\-\-+/g, '-')         // Replace multiple - with single -
             .replace(/^-+/, '')             // Trim - from start of text
             .replace(/-+$/, '');            // Trim - from end of text
}

// money format handler
if (!Shopify.formatMoney) {
  Shopify.money_format = "${{amount}}";
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}